<template>
	<div>
		<div>
			集中器地址：{{theGprsAddr}}
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"
					   rowKey="collectorAddr" :pagination="false" :scoll="{y:400}" style="margin:1.25rem 0;">
					<span slot="theAction"  slot-scope="text, record">
						<a-button size="small" icon="menu-unfold" type="link" :loading="dispatchFlag && theCollector == record " @click="deliveryAddress(record)">下发地址</a-button>
						<a-button size="small" icon="control" type="link" @click="editCollectorAddr(record)">修改采集器地址</a-button>
					</span>
		</a-table>
		<a-divider v-if="showFlag">修改采集器地址</a-divider>
		<a-form-model  v-if="showFlag" ref="addForm"  :model="newForm" layout="inline" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
			<a-form-model-item label="采集器地址" prop="newAddr">
				<a-input  v-model="newForm.newAddr" style="width: 22.5rem;"/>
			</a-form-model-item>
		</a-form-model>
		<div  style="margin-top: 1rem;float: right;"  v-if="showFlag">
			<a-button icon="close" @click="showFlag = false" style="margin-right: 0.625rem;">取 消</a-button>
			<a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	const columns = [
		{ title: '采集器地址', dataIndex: 'collectorAddr',ellipsis :true},
		{ title: '操作',scopedSlots: { customRender: 'theAction' },align:'center',width:260}
	];
	export default{
		props:[
			'theObj',
		],
		data(){
			return {
				columns,
				list:[],
				loading:true,
				showFlag:false,
				submitFlag:false,
				dispatchFlag:false,
				theCollector:{},
				newForm:{
					newAddr:null,
					oldAddr:null,
				},
				rules:{
					newAddr:[{required:true,message:'请输入采集器地址',trigger: 'blur'}],
				}, 
			}
		},
		methods:{
			deliveryAddress:function(item){
				this.theCollector = item;
				this.dispatchFlag = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_DISPATCH_ADDRESS_URL);
				let param = {gprsAddr:this.theObj.gprsAddr,collectorAddr: item.collectorAddr};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.dispatchFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg,1.5);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.dispatchFlag = false;
					console.log(error);
				});
			},
			
			editCollectorAddr:function(item){
				this.showFlag = true;
				this.newForm.newAddr  = item.collectorAddr;
				this.newForm.oldAddr =  item.collectorAddr;
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
					this.submitFlag = true;
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_UPDATE_COLLECTOR_ADDR_URL);
					this.newForm.gprsId = this.theObj.pId;
					this.Api.fetchPostWithForm(url,this.newForm).then((data)=>{
						this.submitFlag = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success('修改成功');
							this.queryDataList();
							this.showFlag = false;
						}else{
							this.$message.error(msg);
						}
					}).catch((errorr)=>{
						console.log(errorr);
						this.submitFlag = false;
					});
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_COLLECTORS_WITH_GPRS_URL);
				let param = {gprsId:this.theObj.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
		},
		created() {
			this.queryDataList();
		},
		computed:{
			theGprsAddr:function(){
				return this.theObj.gprsAddr;
			}
		}
	}
</script>

<style>
</style>
